import React from 'react';

import { type RouteComponentProps, Redirect, Route, Switch } from 'react-router';

import LazyComponent from '@fd/ui/LazyComponent';

import { lazyWithRetry } from '../../helpers/utilities';
import ErrorBoundary from '../../layouts/Portal/ErrorBoundary';
import { PortalFeatureFlags } from '../../services/featureFlags/portalFeatureFlags';
import { useFeatureFlagValue } from '../../services/featureFlags/useFeatureFlagValue';

const MicroFrontendExample = lazyWithRetry(() => import('./FlipdishPhoneMarketing'));

type RouteParams = {
  appId?: string;
};

type ViewRouteParams = {
  appId?: string;
  propertyId: string;
  salesChannelId: string;
};

type Props = RouteComponentProps<RouteParams>;

const FlipdishPhoneMarketingRoutes: React.FC<Props> = (props: Props) => {
  const {
    match: { path, params },
  } = props;

  const isCutoverOn = useFeatureFlagValue(PortalFeatureFlags.phoneAgentCutover, false);
  const appId = params?.appId ?? '';

  return (
    <ErrorBoundary identifier="flipdish-phone-marketing-mf">
      <Switch>
        {isCutoverOn && (
          <Route
            exact
            path={`${path}/view/:propertyId/:salesChannelId`}
            render={({ match, location }) => {
              const { propertyId, salesChannelId } = match.params as ViewRouteParams;
              const targetAppId = (match.params as ViewRouteParams).appId || appId;
              if (!targetAppId) {
                return null;
              }
              return (
                <Redirect
                  to={{
                    pathname: `/${targetAppId}/phone-agent/setup/properties/${propertyId}/sales-channel/${salesChannelId}`,
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              );
            }}
          />
        )}
        {isCutoverOn && (
          <Route
            render={({ location }) => {
              if (!appId) {
                return null;
              }
              return (
                <Redirect
                  to={{
                    pathname: `/${appId}/phone-agent/setup`,
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              );
            }}
          />
        )}
        {!isCutoverOn && (
          <Route
            path={`${path}`}
            render={() => (
              <LazyComponent>
                <MicroFrontendExample />
              </LazyComponent>
            )}
          />
        )}
      </Switch>
    </ErrorBoundary>
  );
};

export default FlipdishPhoneMarketingRoutes;
